<template>
  <div class="cmp-distribution-imports dt-page">
    <div class="dt-page--top-bar v1" style="padding: 0px 10px">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img @click="onAddImportModalClick" class="dt-icon s1" src="static/buttons/add.svg" title="Add Import"
            alt="Add Import" />
        </div>
      </div>
      <div class="search">
        <InputField   :value="searchString" :placeholder="'Search'" :config="{
          borderStyle: 'bottom',
          maxWidth: '200px',
          minWidth: '200px',
          width: '200px',
        }" @keyup="onSearchInputKeyup"></InputField>
        <div style="width: 20px"></div>
        <Dropdown :options="channelTV" :selected="channelTV.find((e) => e.value == selectedChannel)"
          :placeholder="'Channel'" deselect borderbottom :listHeight="300" @selectedChange="(e) => channelChange(e)">
        </Dropdown>
        <!-- <button
          style="margin-top: 8px; margin-left: 0px"
          class="dt-button v5 s8"
          @click="onRefresh"
        >
          Refresh
        </button> -->
      </div>
      <div class="right-container ut-colcen">
        <div class="ut-flex">
          <div class="month-navigation">
            <img @click="previousClick" class="dt-icon v5 s1" src="static/icons/arrows/chevron-left.svg" alt />
            <img @click="nextClick" class="dt-icon v5 s1" src="static/icons/arrows/chevron-right.svg" alt />
          </div>
          <!-- <InputField
            :value="years.find((e) => e.value == currentYear).value"
            style="text-align: center"
            :placeholder="''"
            :config="{
              borderStyle: 'bottom',
              maxWidth: '140px',
              minWidth: '140px',
              width: '140px',
              noicon: true,
            }"
            disabled
            @keyup="onSearchInputKeyup"
          /> -->
          <Dropdown :options="yearsWithHalfIndicator" :selected="selectedDate" :placeholder="'Year'" deselect borderbottom
            style="width: 124px" @selectedChange="(e) => yearChange(e)"></Dropdown>
        </div>
      </div>
    </div>
    <div class="dt-page--body" :style="{ '--offset': '120px', padding: '0px 12px' }">
      <div class="statement_settings--header" ref="ssheader">
        <div class="statement_settings--row header">
          <div class="statement_settings--main">{{$t('statements')}}</div>
          <div class="statement_settings--months">
            <div class="statement_settings--month" v-for="month of currentHalfYearMonths" :key="month">
              {{ month }}
            </div>
          </div>
        </div>
      </div>
      <div class="statement_settings--body"  @scroll="onListScroll">
        <template  >
          <div v-for="statement_setting of list || []" :key="statement_setting.statement_setting_id"
            class="statement_settings--row">
            <div class="statement_settings--main">
              <div class="statement_settings--account_name">
                {{ statement_setting.account_name }}
              </div>
              <div class="statement_settings--description">
                {{ statement_setting.description }}
              </div>
            </div>
            <div class="statement_settings--months">
              <StatementSettingsMonth v-for="month of currentHalfYearMonths" :key="month" :currentYear="currentYear"
                :month="month" :statement_setting="statement_setting" :maxStatements="maxStatementsOfHalfYearMonths(currentYear, statement_setting)
                  " @import_click="onAddImportClick" @statment_click="onStatementClick"
                @deleteStatement="deleteStatement" @rp_click="onRPClick" />
            </div>
          </div>
          <div style="height: 52px"></div>
        </template>
        <div v-if="loadingFlag" style="
            width: 100%;
            display: flex;
            position: fixed;
            top: 400px;
            left: 100px;
            opacity: 0.65;"
        >
          <img style="margin: 0 auto" src="static/icons/loading.gif" class="v5 s2" />
        </div>
      </div>

      <div class="statement_settings--statuses">
        <div class="statement_settings--status">
          <div class="statement_settings--status--color bc-cornblue"></div>
          <div class="statement_settings--status--text">{{ $t('auto_imports') }}</div>
        </div>
        <div class="statement_settings--status">
          <div class="statement_settings--status--color bc-confetti"></div>
          <div class="statement_settings--status--text">{{ $t('import_expected') }}</div>
        </div>
        <div class="statement_settings--status">
          <div class="statement_settings--status--color bc-crusta"></div>
          <div class="statement_settings--status--text">{{ $t('open_import') }}</div>
        </div>
        <div class="statement_settings--status">
          <div class="statement_settings--status--color bc-emerald"></div>
          <div class="statement_settings--status--text">{{ $t('import_complete') }}</div>
        </div>
        <div class="statement_settings--status">
          <div class="statement_settings--status--color bc-850"></div>
          <div class="statement_settings--status--text">{{ $t('no_expected_import') }}</div>
        </div>
        <div class="statement_settings--status">
          <div class="statement_settings--status--color bc-warning"></div>
          <div class="statement_settings--status--text">{{ $t('warning') }}</div>
        </div>
      </div>
    </div>
    <input type="file" id="filepicker" @input="onFilePickerChange" style="visibility: hidden; display: none"
      accept=".xls, .xlsx, .csv, .txt, .tab, .tsv" name="filepicker" />
    <v-dialog v-model="fileUploadingFlag" persistent width="390">
      <Modal :id="'cmp-distribution-imports-file_uploader'">
        <template slot="header">{{$t('uploading')}}</template>

        <template slot="body">
          <ProgressBar v-if="fileUploadingFlag" :value="uploadProgress" :remainingTimeInMinSec="remainingTimeInMinSec"
            :uploadSpeed="getAverageUploadSpeed()" :duration="fileUploaderDuration" />
          <div v-if="redirectNoticeFlag" class="ut-text-secondary"
            style="margin-top: 40px; text-align: center; font-size: 11px">
           {{$t('uploading_message1')}}
            {{ remainingTimeInMinSec }}.  {{$t('uploading_message2')}}
          </div>
        </template>
        <template slot="options">
          <button v-if="redirectNoticeFlag" class="dt-button v1 s6" @click="continueOnNewTab">
           {{$t('continue_in_new_tab')}}
          </button>
        </template>
      </Modal>
    </v-dialog>

    <ModalContainer :modalKey="'addImports'" :width="'small'">
      <AddImports @cancelled="onAddImportsCancelled" />
    </ModalContainer>
  </div>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import ModalContainer from "@dtplugins/modal/modal-container";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { importsActions } from "../../store/imports/actions";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { importsGetters } from "../../store/imports/getters";

import { flatten, range } from "ramda";
import { DistributionImportsService } from "../../services/imports.service";
import ProgressBar from "../../../../plugins/progress-bar/progress-bar.vue";
import { distributionStatementListLDTRoutes } from "../../router/routes";
import { routeWithFrom } from "../../../../utility/route";
import {
  executeFunctionExpIntP,
  openNewTab,
  subscribeSubject,
  wait,
} from "../../../../utility";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import {
  closeModalRoute,
  createModalMixin,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import {
  getCurrentHalfYear,
  getCurrentYear,
} from "../../../../utility/calendar";
import {
  confirmMessage,
  confirmOK,
} from "../../../../dt-plugins/confirmation/confirmation-common";

import StatementSettingsMonth from "./statement_settings_month.vue";
import AddImports from "./add-imports.vue";
import { Subject } from "rxjs";
import { distributionStatementsActions } from "../../store/statement/actions";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { createFileUploaderProgress } from "../../../../dt-plugins/file-uploader/file-uploader.mixin";
export default {
  components: {
    Modal,
    ModalContainer,
    ProgressBar,

    StatementSettingsMonth,
    AddImports,
  },
  mounted: async function () {
    setMainNavInactive(this.$store.commit, false);
    subscribeSubject(this, this.subjectSearchSubject, (searchString) => {
      this.fetchListReset();
    })
     // this.fetchList();
  },
  data: function () {
    return {
      yearMonths: [
        [1, 2, 3, 4, 5, 6],
        [7, 8, 9, 10, 11, 12],
      ],
      // currentYear: getCurrentYear(),
      // currentHalfYear: getCurrentHalfYear(),

      file: null,
      statement_setting: null,
      fileUploadingFlag: false,
      fileUploaderDuration: 500,
      fileUploaderProgress: 0,
      settingsList: [],
      subjectSearchSubject: new Subject(),
      loading: true,

      // uploadProgress: 0,
      // startTime: null,
      // totalElapsedTime: 0,
      // redirectNoticeFlag: false,
      // redirectedFlag: false,
      // calcStartTime: null,
      // lastUploadedBytes: 0,
      // remainingTime: null,
      // uploadSpeed: 0,
      // lastUploadSpeeds: [],
    };
  },
  mixins: [ createFetchListMixin(ActionTypes.ImportsList.FETCH.ALL, 30, {
      advancedSearchable: false,
      searchable: true,
      scrollable: true,
    }),createModalMixin("addImports"), createFileUploaderProgress()],
  computed: {
    ...mapGetterObject(storeNS, importsGetters),
    startDate() {
      const semestar = this.basicFilterData?.semestarDate?.split(" ")?.[1];
      return semestar == "(1/2)"
        ? `${this.currentYear}-01-01`
        : semestar == "(2/2)"
          ? `${this.currentYear}-07-01`
          : `${this.currentYear}-01-01`
    },
    endDate() {
      const semestar = this.basicFilterData?.semestarDate?.split(" ")?.[1];
      return semestar == "(1/2)"
        ? `${this.currentYear}-06-30`
        : semestar == "(2/2)"
          ? `${this.currentYear}-12-31`
          : `${this.currentYear}-06-30`

    },
    
    currentHalfYearMonths() {
      return this.yearMonths[this.currentHalfYear];
    },
    selectedChannel() {
      return this.basicFilterData?.channel || "";
    },
    searchString() {
      return this.basicFilterData?.searchString || "";
    },
    selectedDate() {
      return this.yearsWithHalfIndicator.find(
        (e) => e.value == this.semestarDate
      );
    },
    

    currentYear() {
      return (
        this.basicFilterData?.semestarDate?.split(" ")?.[0] || getCurrentYear()
      );
    },
    
    currentHalfYear() {
      const semestar = this.basicFilterData?.semestarDate?.split(" ")?.[1];
      return semestar == "(1/2)"
        ? 0
        : semestar == "(2/2)"
          ? 1
          : getCurrentHalfYear();
    },
    semestarDate() {
      return (
        this.basicFilterData?.semestarDate ||
        `${getCurrentYear()} ${getCurrentHalfYear() == 0 ? "(1/2)" : "(2/2)"}`
      );
    },

    yearsWithHalfIndicator() {
      // return range(1970, 2101).map((e) => ({ text: e, value: e }));
      return flatten(
        range(1980, 2050).map((e) => {
          const firstHalf = `${e} (1/2)`;
          const secondHalf = `${e} (2/2)`;
          return [
            { text: firstHalf, value: firstHalf },
            { text: secondHalf, value: secondHalf },
          ];
        })
      );
    },
    years() {
      return range(1980, 2050).map((e) => ({ text: e, value: e }));
    },
    channelTV: function () {
      return [
        { text: "Digital", value: "digital" },
        { text: "Physical", value: "physical" },
        { text: "Costs", value: "costs" },
        { text: "Third Party", value: "thirdparty" },
        { text: "Performance", value: "performance" },
        { text: "Other Income", value: "income" },
        { text: "Inactive", value: "inactive" },
      ];
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: {
          searchString:this.searchString,
          channel:this.selectedChannel,
          endDate:this.endDate,
          startDate:this.startDate,
        },
        searchFilter: this.searchFilter,
      };
    },
    list: function () {
      
      this.settingsList =
        this.importsList && this.importsList?.statement_settings
          ? [...this.importsList.statement_settings]
          : [];

      return this.settingsList.filter(
        (e) => e.active_flag == 1 || e.active_flag == "1"
      );

    },

    showAutoImport: function () {
      return this.list.reduce((accum, cur) => {
        if (cur.sender == null) {
          accum = false;
        }
        return accum;
      }, true);
    },

  },
  methods: {
    ...mapActionObject(storeNS, importsActions),
    ...mapActionObject(storeNS, distributionStatementsActions),
    
    defaultBasicFilter() {
      return {
        searchString: this.searchString,
        channel: this.selectedChannel,
        startDate: this.startDate,
        endDate:this.endDate,
        semestarDate:this.semestarDate
      };
    },

    onSearchInputKeyup(event) {
      this[ActionTypes.BasicFilter.SET.SINGLE]({
        ...this.basicFilterData,
        searchString: event.target.value,
      });
      console.log(event.target.value)
     this.subjectSearchSubject.next(event.target.value)
    },
    getStatements(statement_setting, month) {
      return statement_setting.statements.filter((st) => {
        if (
          st.statement_period_txt == `M${month}` &&
          this.currentYear == st.statement_year
        ) {
          return true;
        }
      });
    },
    async channelChange(e) {
      await this[ActionTypes.BasicFilter.SET.SINGLE]({
        ...this.basicFilterData,
        channel: e.value,
      });

      this.basicFilter['channel']=e.value;
      this.fetchListReset();
    },
    async previousClick() {
      let currentYear = +this.currentYear;
      let currentHalfYear = +this.currentHalfYear;

      // console.log(this.currentYear, this.currentHalfYear);
      if (this.currentHalfYear - 1 < 0) {
        currentYear -= 1;
        currentHalfYear = 1;
      } else {
        currentHalfYear -= 1;
      }
      this.setSemestarDate({
        currentYear,
        currentHalfYear,
      });
    },
    async nextClick() {
      let currentYear = +this.currentYear;
      let currentHalfYear = +this.currentHalfYear;
      // console.log(this.currentYear, this.currentHalfYear);

      if (this.currentHalfYear + 1 > 1) {
        currentYear += 1;
        currentHalfYear = 0;
      } else {
        currentHalfYear += 1;
      }
      this.setSemestarDate({
        currentYear,
        currentHalfYear,
      });
    },
    async setSemestarDate({
      currentYear = getCurrentYear(),
      currentHalfYear = getCurrentHalfYear(),
    }) {
      await this[ActionTypes.BasicFilter.SET.SINGLE]({
        ...this.basicFilterData,
        semestarDate: `${currentYear} ${currentHalfYear == 0 ? "(1/2)" : "(2/2)"
          }`,
      });
      this.basicFilter['semestarDate']=`${currentYear} ${currentHalfYear == 0 ? "(1/2)" : "(2/2)"}`
      this.fetchListReset();
    },
    async yearChange(e) {
      await this[ActionTypes.BasicFilter.SET.SINGLE]({
        ...this.basicFilterData,
        semestarDate: e.value,
      });
      console.log(e.value)
      this.basicFilter['semestarDate']=e.value;
      this.fetchListReset();
    },

    onFilePickerChange: async function (event) {
      // console.log({ onFilePickerChange: 1 });
      const files = event.target.files;
      if (files.length > 0) {
        this.file = files[0];
      }
      // console.log({
      //   statement_setting: this.statement_setting,
      //   file: this.file,
      // });

      const formData = new FormData();
      formData.append("section", "statementsin");
      formData.append("action", "new_statement_with_file");
      formData.append(
        "statement_setting_id",
        this.statement_setting.statement_setting_id
      );
      formData.append("statement_year", this.statement_setting.year);
      formData.append(
        "statement_period_txt",
        `M${this.statement_setting.month}`
      );
      formData.append("dss_id", this.statement_setting.dss_id);

      //formData.append("file_type", this.file?.type?.split("/")?.[1]);
      const file_types_pattern = /\.(xls|xlsx|csv|txt|tab|tsv)$/i; ///\.Add file extesion

      const matches = String(this.file?.name || "").match(file_types_pattern);
      if (!matches) {
        const confirmation = await ConfirmationService.createP({
          body: this.$t("Only xls ,xlsx ,csv ,txt ,tab ,tsv file is allowed"),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });

        return;
      }
      // console.log(matches, ":::::::::::matches");
      formData.append("file_type", matches[1]);
      formData.append("file_name_str", this.file?.name);
      formData.append("file_name", this.file);

      this.fileUploadingFlag = true;

      await wait(50);
      // this.fileUploaderProgress = 80;
      let res;
      res = await DistributionImportsService.uploadFile(formData, {
        onUploadProgress: this.onUploadProgress,
      });

      console.log("RES", res);

      const dss = res.data.dss;

      // if (this.$store.getters.account.user.user_name == "geralt") {
      // } else {
      //   res = await DistributionImportsService.uploadFile(formData);
      // }
      this.fileUploadingFlag = false;
      this.resetUploaderData();

      // console.log(res, ":::::::::::::::::::");

      // Finish the Progressbar animation
      // this.fileUploaderDuration = 600;
      await wait(5);
      this.fetchListReset();
      // this.fileUploaderProgress = 100;

      if (dss == 1) {
        const { write_time, statement } = res.data;
        const { statement_id } = statement;

        await DistributionImportsService.processStatement(
          statement_id,
          matches[1],
          write_time
        );
        this.onCancel();
        return;
      }

      await wait(600);
      await this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({
        flag: true,
        reload: false,
        statement: res.data.statement,
      });
      await this[ActionTypes.DistributionStatementFile.INSERT.MULTIPLE]({
        file: res.data.file,
        statement_id: res.data.statement.statement_id,
      });
      routeWithFrom(this, {
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id: res.data.statement.statement_id,
          tab: "import",
        },
      });

      this.onCancel();
      // this.$router.push({
      // });
    },
    onAddImportClick(statement_setting) {
      this.statement_setting = statement_setting;
      document.querySelector("#filepicker").click();
    },
    onCancel() {
      this.file = null;
      this.fileUploadingFlag = false;
      // console.log({ "this.fileUploadingFlag": this.fileUploadingFlag });
    },
    onStatementClick(statement) {
      // console.log('statement',statement)
      const tab =
        statement.import_status == "complete"
          ? "import_matching"
          : statement.import_status == "matching_complete"
            ? "import_result"
            : statement.invoice_ref
              ? "import_result"
              : "import";
      // console.log("tab", tab, "import_status", statement?.import_status);

      routeWithFrom(this, {
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id: statement.statement_id,
          tab: tab,
        },
      });
    },
    async onRPClick({
      sender_royalty_periodTitle,
      statement_setting_senderTitle,
      sender_royalty_period,
      statement_setting,
      statement_period_txt,
      year,
    }) {
      // console.log({
      //   "imports.vue:630 statement_settings": statement_setting,
      //   sender_royalty_period,
      // });
      const { statement_setting_id, sender } = statement_setting;

      const { royalty_period_id } = sender_royalty_period;

      // console.log({
      //   statement_setting_id,
      //   sender,
      //   royalty_period_id,
      //   year,
      //   period: statement_period_txt,
      // });
      // return;

      console.log({
        statement_period_txt,
        year,
      });

      const confirmationResult = await confirmMessage(
        `Do you want to import ${sender_royalty_periodTitle} from ${statement_setting_senderTitle} ?`
      );

      if (confirmationResult == "OK") {
        const newStatement = await DistributionImportsService.createStatement({
          statement_setting_id,
          sender,
          royalty_period_id,
          year,
          period: statement_period_txt,
        });
        await this[ActionTypes.SET_IMPORT_SENDER_RP_STATUS]({
          status: "Processing...",
          statement_setting_id: statement_setting.statement_setting_id,
          royalty_period_id: sender_royalty_period.royalty_period_id,
        });

        executeFunctionExpIntP(
          async () => {
            this.fetchListWithoutLoading();
            // console.log({
            //   sl: this.settingsList,
            //   statement_setting: this.settingsList.find(
            //     (e) =>
            //       e.statement_setting_id ==
            //       statement_setting.statement_setting_id
            //   ),
            //   sender_royalty_period: this.settingsList
            //     .find(
            //       (e) =>
            //         e.statement_setting_id ==
            //         statement_setting.statement_setting_id
            //     )
            //     ?.sender_royalty_periods.find(
            //       (e) =>
            //         e.royalty_period_id ==
            //         sender_royalty_period.royalty_period_id
            //     ),
            // });
          },
          (count) => {
            const newSRP = this.settingsList
              .find(
                (e) =>
                  e.statement_setting_id ==
                  statement_setting.statement_setting_id
              )
              ?.sender_royalty_periods.find(
                (e) =>
                  e.royalty_period_id == sender_royalty_period.royalty_period_id
              );

            // console.log({'imports.vue:720 newSRP' : newSRP, stIsProcng: newSRP?.status != "Processing..."});
            return count > 6 || newSRP?.status != "Processing...";
          },
          1,
          2000
        );

        await confirmOK(`You will be notified once the processing is complete`);
      }

      // console.log({ confirmationResult: confirmationResult });
    },
    onAddImportModalClick() {
      openModalRoute2(this, "addImports");
    },
    onAddImportsCancelled() {
      closeModalRoute(this);
    },
    onRefresh: function () {
      // this.selectedChannel='';
      // this.searchString=''

      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    deleteStatement: async function (item) {
      const confirmationResult = await confirmDelete(
        "Statement",
        item.account_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.ImportsList.DELETE.SINGLE](item);
      }
    },
    maxStatementsOfHalfYearMonths(currentYear, statement_setting) {
      // return 3;
      const halfYearMonths =
        this.currentHalfYear == 0 ? [1, 2, 3, 4, 5, 6] : [7, 8, 9, 10, 11, 12];

      // console.log({ currentYear, halfYearMonths, statement_setting });

      const halfYearMonthStatements = halfYearMonths?.map((month) => {
        return statement_setting?.statements?.filter((st) => {
          // if (
          //   statement_setting.account_name == "Bandcamp" &&
          //   statement_setting.description == "BC physical"
          // ) {
          //   console.log({
          //     month,
          //     currentYear,
          //     statement_period_txt: st.statement_period_txt,
          //     statement_year: st.statement_year,
          //   });
          // }
          if (
            this.matchStatementSettingsPeriod(st, month) &&
            // (st.statement_period_txt == `M${month}` ||
            //   (month % 3 == 0 &&
            //     st.statement_period_txt == `Q${Math.floor(month / 3)}`)) &&
            currentYear == st.statement_year
          ) {
            // if (
            //   statement_setting.account_name == "Bongo Joe" &&
            //   statement_setting.description == "Cost Import EUR"
            // ) {
            //   console.log('CONDITION MATCHED', {
            //     month,
            //     statement_period_txt: st.statement_period_txt,
            //     currentYear,
            //     statement_year: st.statement_year,
            //     sp: st.statement_period,
            //     st,
            //   });
            // }

            return true;
          }
        });
      });

      // if (
      //   statement_setting.account_name == "1Live" &&
      //   statement_setting.description == "111"
      // ) {
      //   console.log({ halfYearMonthStatements });
      // }

      // console.log({ sa: statement_setting.account_name, description: statement_setting.description, halfYearMonthStatements });

      const maxStatementsOfHalfYearMonths = Math.max(
        ...halfYearMonthStatements.map((st) => st.length)
      );
      return maxStatementsOfHalfYearMonths > 0
        ? maxStatementsOfHalfYearMonths
        : 1;
    },
    matchStatementSettingsPeriod(statement_setting, month) {
      const periodTextIdentifier =
        statement_setting?.statement_period_txt?.slice(0, 1);
      const statement_period = statement_setting.statement_period
        ? statement_setting.statement_period
        : {
          M: "monthly",
          Q: "quarterly",
          S: "halfyear",
          Y: "year",
        }[periodTextIdentifier];

      const isQuaterPeriod = statement_period == "quarterly";
      const isHalfYearPeriod = statement_period == "halfyear";
      const isYearPeriod = statement_period == "year";
      const isMonthPeriod = statement_period == "monthly";

      // const isMonthPeriodEnded = true;
      const quarterEnded =
        statement_setting?.statement_period_txt ==
        `${periodTextIdentifier}${Math.floor(month / 3)}`;
      const halfYearEnded =
        statement_setting?.statement_period_txt ==
        `${periodTextIdentifier}${Math.ceil(month / 6)}`;
      const yearEnded = month == 12;
      const monthEnded =
        statement_setting?.statement_period_txt ==
        `${periodTextIdentifier}${month}`;

      if (
        (isQuaterPeriod ? quarterEnded : true) &&
        (isHalfYearPeriod ? halfYearEnded : true) &&
        (isYearPeriod ? yearEnded : true) &&
        (isMonthPeriod ? monthEnded : true)
      ) {
        return true;
      }
    },
    onSSBodyScroll(e) {
      const scrollLeft = e.target.scrollLeft;
      // console.log({ "imports.vue:683 scrollLeft": scrollLeft });
      // console.log({
      //   'imports.vue:685 this.$refs["ssheader"]': this.$refs["ssheader"],
      // });
      if (
        this.$refs["ssheader"] &&
        this.$refs["ssheader"]?.scrollLeft != scrollLeft
      ) {
        this.$refs["ssheader"].scrollLeft = scrollLeft;
      }
    },
    // resetUploadSpeed() {
    //   this.lastUploadSpeeds = [];
    // },
    // insertNewUploadSpeed(speed) {
    //   // Allow Maximum 3 Upload Speed
    //   if (this.lastUploadSpeeds.length > 2) {
    //     this.lastUploadSpeeds.shift();
    //   }
    //   this.lastUploadSpeeds.push(speed);
    // },
    // getAverageUploadSpeed() {
    //   return (
    //     this.lastUploadSpeeds.reduce((accum, cur) => accum + cur, 0) /
    //       this.lastUploadSpeeds.length || 1
    //   );
    // },
    // resetUploaderData() {
    //   this.uploadProgress = 0;
    //   this.startTime = null;
    //   this.totalElapsedTime = 0;
    //   this.redirectNoticeFlag = false;
    //   this.redirectedFlag = false;
    //   this.calcStartTime = null;
    //   this.lastUploadedBytes = 0;
    //   this.remainingTime = null;
    //   this.uploadSpeed = 0;
    //   this.lastUploadSpeeds = [];
    // },
    continueOnNewTab() {
      this.redirectNoticeFlag = false;
      this.redirectedFlag = true;
      // Duplicate the current tab in a new Tab and continue there
      openNewTab(window.location.href);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-imports {
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }

    .dropdown {
      width: 160px;
      margin-right: 10px;
    }
  }

  .dt-page--body {
    overflow: auto;
    overflow-x: hidden;

    --statement-settings-row-height: 52px;
    // @media screen and (min-width: 1032px) {
    //   --statement-settings-row-height: 74px;
    // }

    .statement_settings--statuses {
      position: absolute;
      display: flex;
      bottom: 20px;

      padding: 4px;
      background: white;

      box-shadow: 0px 3px 20px #00002433;
      border-radius: 6px;

      .statement_settings--status {
        display: flex;
        margin: 0px 8px;
        align-items: center;

        &:first-child {
          /* margin-left: 8px; */
        }

        .statement_settings--status--color {
          margin: 0px 6px;
          width: 5px;
          height: 13px;
          border-radius: 8px;
        }
      }
    }
  }

  .statement_settings--header {
    padding-right: var(--scrollbar-width);
    overflow-x: hidden;

    .statement_settings--row {
      height: var(--statement-settings-row-height);
    }
  }

  .statement_settings--body {
    height: calc(100vh - 172px);
    overflow: auto;
    // scrollbar-width: thin;
    // padding-bottom: var(--statement-settings-row-height);
  }

  .statement_settings--row {
    display: flex;
    // border-bottom: 1px solid var(--sprt-85);

    &:not(.header) {
      .statement_settings--main {
        border-bottom: 1px solid var(--sprt-85);
      }
    }

    .statement_settings--main {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      flex: 2.3;
      min-width: 250px;
      max-width: 250px;

      .statement_settings--account_name {
        font-weight: 700;
      }
    }

    .statement_settings--months {
      flex: 7.3;
      display: flex;
      width: 100%;

      .statement_settings--month {
        border-bottom: 1px solid var(--sprt-85);

        flex: 1;
        min-height: var(--statement-settings-row-height);
        max-height: 100%;
        min-width: 155px;

        border-left: 1px solid var(--sprt-85);

        &:last-child {
          border-right: 1px solid var(--sprt-85);
        }

        &.multi-statement {
          .statement_settings--statement {
            &:first-child {
              /* border-bottom: 1px solid var(--sprt-85); */
            }
          }

          /* .statement_settings--statement:first-child {
            } */
        }

        .statement_settings--statement {
          cursor: pointer;
          display: flex;
          align-items: center;
          height: var(--statement-settings-row-height);

          position: relative;

          /* border-bottom: 1px solid var(--sprt-85); */

          /* &:not(:first-child) {
            border-top: 1px solid var(--sprt-85);
          } */
          /* &:first-child {
            border-bottom: 1px solid var(--sprt-85);
          } */

          &.stgreen {
            background: var(--emerald-a20);
            color: var(--viridian);

            .left-bar {
              background: var(--emerald);
            }
          }

          &.styellow {
            background: var(--confetti-a20);

            .left-bar {
              background: var(--confetti);
            }

            .import_status {
              min-height: 13px;
            }
          }

          &.stred {
            background: var(--crusta-a20);

            color: var(--crusta);

            .left-bar {
              background: var(--crusta);
            }

            .import_status {
              font-weight: 500;
            }
          }

          &.storange {
            background: var(--mysin-a20);

            color: var(--mysin);

            .left-bar {
              background: var(--mysin);
            }

            .import_status {
              font-weight: 500;
            }
          }

          &.stblue {
            background: var(--cornblue-a20);
            color: var(--cornblue);

            .left-bar {
              background: var(--cornblue);
            }

            .import_status {
              min-height: 13px;
            }
          }

          .left-bar {
            height: 38px;
            max-width: 5px;
            width: 5px;
            margin: 0px 6px 0px 11.5px;
            border-radius: 8px;
            background: var(--bc-850);
          }

          &:hover {
            .add-icon {
              background: var(--bc-820);

              .add-icon--plus {
                color: var(--text-5);
              }

              .add-icon--text {
                opacity: 1;
              }
            }
          }

          &:hover {
            .right-icon {

              // background: var(--bc-820);
              .add-icon--plus {
                // color: var(--text-5);
                opacity: 0.8;
              }
            }
          }

          .right-icon {
            position: absolute;
            right: 0px;

            cursor: pointer;
            display: flex;
            // padding: 1px 3px;
            border-radius: 4px;
            width: 24px;
            overflow: hidden;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            gap: 0.4rem;

            .add-icon--plus {
              transition: 300ms opacity ease-out;

              color: var(--text-primary-a20);
              font-size: 14px;
              font-weight: 300;
              // margin-right: 4px;
              opacity: 0;
              border-radius: 15px;

              &:hover {
                // background-color: var(--bc-820);
                opacity: 1;
              }
            }
          }

          .add-icon {
            cursor: pointer;
            display: flex;
            padding: 1px 7px 1px 6px;
            border-radius: 4px;

            /* &:hover {
              background: var(--bc-820);
              .add-icon--plus {
                color: var(--text-5);
              }
              .add-icon--text {
                opacity: 1;
              }
            } */

            /* color: var(--bc-8); */
            .add-icon--plus {
              transition: 200ms color ease-out;

              color: var(--text-primary-a20);
              font-size: 14px;
              font-weight: 300;
              margin-right: 4px;
            }

            .add-icon--text {
              transition: 200ms opacity ease-out;
              color: var(--text-5);
              opacity: 0;
            }
          }

          .statement-details {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;

            .invoice_ref {
              font-weight: 600;

              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              max-width: calc(max(9vw, 130px));
            }

            .statement_amount {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              max-width: calc(max(9vw, 130px));
            }

            // @media screen and (min-width: 1032px) {
            //   // .invoice_ref.ut-link.ut-font-upper {
            //   //   margin-top: 14px;
            //   // }
            //   // .import_status.ut-link {
            //   //   margin-top: 14px;
            //   // }
            //   .invoice_ref,
            //   .import_status,
            //   .statement_amount {
            //     white-space: normal;
            //   }
            // }

            /* .import_status {
              
            } */
          }
        }
      }
    }

    &.header {
      .statement_settings--main {
        color: var(--text-accent);
        border-bottom: 1px solid var(--bc-accent);
      }

      .statement_settings--months {
        color: var(--text-accent);

        .statement_settings--month {
          border-bottom: 1px solid var(--bc-accent);

          display: flex;
          justify-content: center;
          align-items: center;

          border-left: 1px solid transparent;

          &:last-child {
            border-right: 1px solid transparent;
          }
        }
      }
    }
  }
}

// ds
</style>

